module.exports = __webpack_public_path__ + "static/media/enableFullScreen-dark.b66b7a5c.svg";